import { Loader2 } from 'lucide-react';

import { Checkbox } from '@/components/ui/checkbox';
import { DataLoader } from '@/components/ui/DataLoader';
import { Label } from '@/components/ui/label';
import type { LpAllocations } from '@/types/lpAllocation';

import type { LpAllocationEditor } from './useLpAllocationEditor';

export function CustomAllocationCheckbox({
  editor,
}: {
  editor: LpAllocationEditor;
}) {
  return (
    <DataLoader
      query={editor.allocationsQuery}
      loadingComponent={
        <Loader2
          className="h-4 w-4 animate-spin text-muted-foreground"
          data-testid="loading"
        />
      }
      errorClassName="p-0"
    >
      {(allocations: LpAllocations) => {
        const checkboxId = `custom-allocation-${allocations.fund_transaction_id}`;
        return (
          <div className="flex items-center gap-2">
            <Checkbox
              id={checkboxId}
              checked={editor.isTicked}
              disabled={!allocations.is_editable || editor.isSaving}
              onCheckedChange={(checked) =>
                editor.toggleCustom(checked === true)
              }
            />
            <Label htmlFor={checkboxId}>Custom allocation</Label>
          </div>
        );
      }}
    </DataLoader>
  );
}
